import { GetStaticProps } from "next";
import { Key } from "react";
import MainLayout from "../../components/MainLayout";
import { IfeQuery } from "../../graphql/ife";
import { getFooterMenu } from "../../repositories/menu";
import { executeQuery } from "../../services/graphql";
import { IfeQueryRequest } from "../../services/graphql/types/ifeQuery";
import { itemsMenuHierarch } from "../../utils/menuHierarch";
import { CACHE_TIME_DEFAULT } from "../../utils/requests";
import style from "./indice.module.scss";
import { FaqBlock } from "../../components/Article/FAQ";
import { IndicesFinanzero } from "../../types/IndiceFinanzero";
import Link from "next/link";

const IndiceFinanzero = ({
  menu,
  list,
  footerMenu,
  listFAQ,
  IFEText,
  objRenders,
  Months,
  lastIFE,
}: IndicesFinanzero) => {
  return (
    <MainLayout
      head={{ title: "Índice de empréstimo" }}
      headerMenu={menu}
      footerMenu={footerMenu}
      customStyle={{ backgroundColor: "white" }}
    >
      <div className={style.hero}>
        <div className={style.container}>
          <h2>{IFEText?.ifeHeroTitle}</h2>
          <p>{IFEText?.ifeHeroDescription}</p>
          <Link
            className={style.button}
            href={lastIFE.ifeFile.mediaItemUrl}
            download
            rel="noreferrer"
          >
            {IFEText?.ifeHeroButtonText}
          </Link>
        </div>
      </div>
      <div className={[style.content, style.bgPrimary].join(" ")}>
        <div className={style.container}>
          <div className={style.p20}>
            <FaqBlock
              isIFE={true}
              itemsFaq={
                list.length > 0 &&
                list.map((itemYear, indexYear: Key) => ({
                  title: `Todas as edições ${itemYear.year}`,
                  content: (
                    <div key={indexYear}>
                      <ul className={style.ul}>
                        {objRenders[itemYear.year].map(
                          (
                            itemMonth: {
                              ifeFile: { mediaItemUrl: string };
                              month: string | number;
                            },
                            indexMonth: Key
                          ) => (
                            <li key={indexMonth} className={style.li}>
                              <Link
                                href={itemMonth.ifeFile.mediaItemUrl}
                                download
                                rel="noreferrer"
                              >
                                {Months[itemMonth.month]}
                              </Link>
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  ),
                }))
              }
              title={
                <h2
                  className={style.pb20}
                  dangerouslySetInnerHTML={{ __html: IFEText?.ifeSectionTitle }}
                ></h2>
              }
              hideItemTypeFAQPage={true}
            />
          </div>
        </div>
      </div>
      <div className={[style.content, style.bgSecondary].join(" ")}>
        <div className={style.container}>
          <div className={style.p20}>
            <FaqBlock
              isIFE={false}
              itemsFaq={listFAQ}
              title={<h2 className={style.faqTitle}>Perguntas Frequentes</h2>}
            />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const { data } = await executeQuery<IfeQueryRequest>(IfeQuery);
  if (!data) {
    return {
      redirect: {
        permanent: false,
        destination: "/blog/404",
      },
    };
  }

  const Months = {
    "01": "Janeiro",
    "02": "Fevereiro",
    "03": "Março",
    "04": "Abril",
    "05": "Maio",
    "06": "Junho",
    "07": "Julho",
    "08": "Agosto",
    "09": "Setembro",
    "10": "Outubro",
    "11": "Novembro",
    "12": "Dezembro",
  };
  const listIfe = data?.indicesFinanzero?.nodes;
  let listFAQ: Array<{ title: string; content: string }> = [];
  let renders: Array<{
    month: string;
    ifeFile: { mediaItemUrl: string };
    year: number;
  }> = [];
  const list: Array<
    { title: string; year: number; content: string | null } | undefined
  > = [];
  const IFEText = {
    ifeHeroButtonText:
      data?.page?.template?.IFEPageOptions?.ifeHeroButtonText || "",
    ifeHeroDescription:
      data?.page?.template?.IFEPageOptions?.ifeHeroDescription || "",
    ifeHeroTitle: data?.page?.template?.IFEPageOptions?.ifeHeroTitle || "",
    ifeSectionTitle:
      data?.page?.template?.IFEPageOptions?.ifeSectionTitle || "",
  };
  const menu = itemsMenuHierarch(data?.Head?.nodes[0]?.menuItems?.nodes);
  const footerMenu = await getFooterMenu();

  if (data?.page?.template?.IFEPageOptions?.faqList) {
    listFAQ = data?.page?.template?.IFEPageOptions?.faqList;
  }

  let lastYear = 0;

  listIfe.map(
    (item: {
      IFEOptions: { dateOfIfe: string; ifeFile: { mediaItemUrl: string } };
    }) => {
      const listDate = item.IFEOptions.dateOfIfe.split("/");
      const year = Number(listDate[2]);
      const month = listDate[1];
      const find = list.find((itemFind) => itemFind.year == year);

      if (year > lastYear) {
        lastYear = year;
      }

      if (!find) {
        list.push({ title: `Todas as edições ${year}`, year, content: null });
      }

      renders = [...renders, { month, ifeFile: item.IFEOptions.ifeFile, year }];
    }
  );

  const objRenders = renders.reduce(
    (acc, obj) => ({
      ...acc,
      [obj.year]: [...(acc[obj.year] ? acc[obj.year] : []), obj].sort(
        (a, b) => a.month - b.month
      ),
    }),
    {}
  );

  const lastIFE = objRenders[lastYear].at(-1);

  return {
    props: {
      menu,
      footerMenu,
      list,
      objRenders,
      listFAQ,
      IFEText,
      Months,
      lastIFE,
    },
    revalidate: CACHE_TIME_DEFAULT,
  };
};

export default IndiceFinanzero;
